import { createGlobalStyle } from 'styled-components';
import COLORS from './colors';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${COLORS.BLACK};
    font-family: 'Roboto', sans-serif;
  }
  div {
    font-family: 'Roboto', sans-serif;
  }
  h1 {
    color: ${COLORS.NEUTRAL_200};
  }
  h2 {
    color: ${COLORS.NEUTRAL_200};
    font-weight: 700;
    font-size: 27.65px;
    line-height: 32px;
    margin: 0;
    letter-spacing: -0.829px;
  }
  h3 {
    font-size: 19.2px;
    letter-spacing: -0.02em;
    line-height: 24px;
    color: ${COLORS.NEUTRAL_200};
    margin: 0;
    text-align: left;
  }
  h6 {
    color: ${COLORS.PRIMARY_500}
  }
  p {
    color: ${COLORS.NEUTRAL_500};
    font-size: 13.33px;
    line-height: 16px;
    margin: 0;
  }
`;

export default GlobalStyle;
